import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import HowItWorks from "../components/HowItWorks";
import ProductCatalog from "../components/ProductCatalog";
import EarningsCalculator from "../components/EarningsCalculator";
import Testimonials from "../components/Testimonials";
import RegistrationForm from "../components/RegistrationForm";
import WhatsAppFAB from "../components/WhatsAppFAB";
import Footer from "../components/Footer";

export default function Landing() {
  return (
    <div className="App" data-testid="landing-page">
      <Navbar />
      <Hero />
      <HowItWorks />
      <ProductCatalog />
      <EarningsCalculator />
      <Testimonials />
      <RegistrationForm />
      <Footer />
      <WhatsAppFAB />
    </div>
  );
}
